import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';
import numeral from 'numeral';



import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { RiFileCloudLine } from "react-icons/ri";

import Page from 'src/components/Page';
import agm from '../../services/agm';
import api from '../../services/api';


import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  name: null,
  description: null,
  type: null,
  mac: null,
  mei: null,
  apn: null,
  frequency: null,
  timeOut: null,
  update: null,
  telemetry: null,
  firmware: null,
  enabled: null,
  activated: null
}

const defaultDependencies = {
  loaded: false
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Chave de Acesso', field: 'item.chave', size: 390, sortable: 'chave', exportable: 0, wrap: 1 },
  { name: 'Nome', field: 'item.nome', size: 390, sortable: 'nome', exportable: 0, wrap: 0 },
  { name: 'Tipo', field: 'item.tipo', size: -1, sortable: 'tipo', exportable: 0, wrap: 0 },
  { name: 'Descrição', field: 'item.descricao', size: 400, sortable: 'descricao', exportable: 0, wrap: 0 },
  { name: 'Formato', field: 'item.formato', size: -1, sortable: 'formato', exportable: 0, wrap: 0 },
  { name: 'Tamanho', field: 'fileSize(item.tamanho)', size: -1, sortable: 'tamanho', exportable: 0, wrap: 0 },
  { name: 'Envio', field: 'formatDate(item.dataEnvio)', size: -1, sortable: 'dataEnvio', exportable: 0, wrap: 0 },
  { name: 'Local', field: '(item.existe) ? item.local : "Não Encontrado"', size: -1, sortable: -1, exportable: 0, wrap: 1 },
];

const defaultEmptyMessage = "Nenhum Arquivo Foi Encontrado.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_HIDE,
  update: LEVEL_ACCESS_HIDE,
  delete: LEVEL_ACCESS_HIDE,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  view: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Arquvios de Ocorrências', refine: 1, label: 'Nome do Arquivo', history: 0 },
  { id: 2, name: 'Arquivos de Unidades', refine: 1, label: 'Nome do Arquivo', history: 0 },
  { id: 3, name: 'Arquivos de Infraestrutura de Unidade', refine: 1, label: 'Nome do Arquivo', history: 0 },
  { id: 4, name: 'Arquivos de Caixinha', refine: 1, label: 'Nome do Arquivo', history: 0 },
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  storage: 'AWS',
  visao: defaultVisions[0]
}

const Storage = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = async (item) => {
    setItem(item);
    await agm.get('/faturamento/edicao/' + item.id, {}, {}).then((response) => {
      if (!response.data.error) {
        setDependencies(
          {
            statuslist: response.data.listaStatus,
            budgets: response.data.orcamentos
          }
        );
        setItem(item);
        setOpenEditionDialog(true);
      } else {
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, info: true, message: error.message });
      setOpenAlert(true);
    })
  }

  const openCreation = async (item) => {
    setItem(item);
    setOpenCreationDialog(true);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Arquivo',
      message: 'Deseja excluir o arquivo selecionado?',
      warn: 'Esta ação irá interferir no acesso ao arquivo.',
      details: ['Não será possível recuperar o arquivo excluido. Todos os processos relacionados ao arquivo apresentarão falha.']
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    refreshItems();
  }

  const updateValues = (values) => {
    agm.put('/devices/' + values._id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao atualizar o arquivo.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    agm.post('/device', values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao criar dispositivo.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const updateDependencies = async (values) => {

  };

  const deleteValues = (values) => {
    api.delete('/devices/' + values.id, {}, {}).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao remover dispositivo.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    agm.post('/arquivos/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de dispositivos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    agm.post('/arquivos/historico', { filtro: value }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / value.registros)) + 1,
          page: value.pagina,
          count: response.data.count,
          rows: response.data.rows
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de arquivos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    agm.post('/arquivos/historico', { filtro: filter }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: toInteger((response.data.count / filter.registros)) + 1,
          page: filter.pagina,
          count: response.data.count,
          rows: response.data.rows,
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de arquivos.', detail: error.message });
      setOpenAlert(true);
    })
  }

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Arquivos"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={RiFileCloudLine}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations
          item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={RiFileCloudLine}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
              />
            </CardContent>
          </Card>
        </Box>

      </Container>
    </Page>
  );
};

export default Storage;